export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/contact/state.js